import { Alert } from 'antd';
import LoadingIndicator from 'components/LoadingIndicator';
import React, { Fragment, lazy, Suspense } from 'react';
import { FormattedMessage } from 'react-intl';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { OrderDisabledReason } from 'types/schema';
import messages from 'utils/messages';

const AlertContainer = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 20px;
`;

const CheckoutStep1Page = lazy(() => import('containers/CheckoutStep1Page'));
const CheckoutStep3Page = lazy(() => import('containers/CheckoutStep3Page'));

const Checkout = ({
  orderDisabled,
  orderDisabledMessage,
  orderDisabledReason,
  setOpenForceUpdateAddressModal,
}: {
  orderDisabled: boolean;
  orderDisabledMessage: string;
  orderDisabledReason?: OrderDisabledReason;
  setOpenForceUpdateAddressModal: (open: boolean) => void;
}) => {
  const loggedIn = !!localStorage.getItem('token');
  return (
    <Fragment>
      {orderDisabled && !!orderDisabledMessage && (
        <AlertContainer>
          <Alert
            message={
              <span>
                {orderDisabledMessage}.{' '}
                {orderDisabledReason === OrderDisabledReason.OutdatedWard && (
                  <span
                    style={{
                      color: '#2F904F',
                      cursor: 'pointer',
                    }}
                    onClick={() => setOpenForceUpdateAddressModal(true)}
                  >
                    <FormattedMessage {...messages.updateNow} />
                  </span>
                )}
              </span>
            }
            type="error"
          />
        </AlertContainer>
      )}

      <Switch>
        <Route
          path="/cart"
          render={(props: any) => (
            <Suspense fallback={<LoadingIndicator />}>
              <CheckoutStep1Page {...props} />
            </Suspense>
          )}
        />
        {loggedIn && (
          <Route
            path="/checkout"
            render={(props: any) => (
              <Suspense fallback={<LoadingIndicator />}>
                <CheckoutStep3Page {...props} />
              </Suspense>
            )}
          />
        )}
        <Redirect to="/cart" />
      </Switch>
    </Fragment>
  );
};

export default withRouter(Checkout as any) as any;
